"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: "RSMAndSP",
      searchQuery: {
        rsmEmpNo: "",
        rsmEmpName: "",
        roleCode: "",
        spSapId: "",
        spFullName: ""
      },
      apiModule: "kpiSet"
    };
  },
  computed: {
    domData: function domData() {
      return {
        rsmEmpNo: {
          label: this.$t("sfe.RSMAndSP.rsmEmpNo"),
          valueKey: "rsmEmpNo"
        },
        rsmEmpName: {
          label: this.$t("sfe.RSMAndSP.rsmEmpName"),
          valueKey: "rsmEmpName"
        },
        roleCode: {
          label: this.$t("sfe.RSMAndSP.roleCode"),
          valueKey: "roleCode"
        },
        spSapId: {
          label: this.$t("sfe.RSMAndSP.spSapId"),
          valueKey: "spSapId"
        },
        spFullName: {
          label: this.$t("sfe.RSMAndSP.spFullName"),
          valueKey: "spFullName"
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.rsmandsp"),
          apiUrl: "/protected/serviceProviderRsmRef/export"
        },
        import: {
          apiUrl: "/protected/serviceProviderRsmRef/import"
        }
      };
    },
    tableDom: function tableDom() {
      return {
        rsmEmpNo: {
          label: this.$t("sfe.RSMAndSP.rsmEmpNo")
        },
        rsmEmpName: {
          label: this.$t("sfe.RSMAndSP.rsmEmpName")
        },
        roleCode: {
          label: this.$t("sfe.RSMAndSP.roleCode")
        },
        spSapId: {
          label: this.$t("sfe.RSMAndSP.spSapId")
        },
        spFullName: {
          label: this.$t("sfe.RSMAndSP.spFullName")
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: "/protected/serviceProviderRsmRef/list"
      };
    }
  }
};